export enum ProfileEventsMaud {
  maudProfilePageEditButtonClicked = 'Maud Profile Page Edit Button Clicked',
  maudEditUserModalAddDisplayNameButtonClicked = 'Maud Edit User Modal Add Display Name Button Clicked',
  maudEditUserModalSaveChangesButtonClicked = 'Maud Edit User Modal Save Changes Button  Clicked',
  maudAboutMeEditButtonClicked = 'Maud About Me Edit Button Clicked',
  maudAboutMeModalSaveChangesButtonClicked = 'Maud About Me Save Changes Button Clicked',
  maudAddOutOfOfficeButtonClicked = 'Maud Add Out Of Office Button Clicked',
  maudAddOutOfOfficeSaveButtonClicked = 'Maud Add Out Of Office Save Button Clicked',
  maudOutOfOfficeDeleteButtonClicked = 'Maud Out Of Office Delete Button Clicked',
  maudOutOfOfficeDeleteConfirmationModalDeleteOutOfOfficeButtonClicked = 'Maud Out Of Office Delete Confirmation Modal Delete Out Of Office Button Clicked',
  maudOutOfOfficeEditButtonClicked = 'Maud Out Of Office Edit Button Clicked',
  maudEditOutOfOfficeSaveButtonClicked = 'Maud Edit Out Of Office Save Button Clicked',
  maudCalendarCardClicked = 'Maud Calendar Card Clicked',
}
export enum ProfileEventsAdmin {
  adminProfilePageEditButtonClicked = 'Admin Profile Page Edit Button Clicked',
  adminEditUserModalAddDisplayNameButtonClicked = 'Admin Edit User Modal Add Display Name Button Clicked',
  adminEditUserModalSaveChangesButtonClicked = 'Admin Edit User Modal Save Changes Button Clicked',
  adminAboutMeEditButtonClicked = 'Admin About Me Edit Button Clicked',
  adminAboutMeModalSaveChangesButtonClicked = 'Admin About Me Save Changes Button Clicked',
  adminAddOutOfOfficeButtonClicked = 'Admin Add Out Of Office Button Clicked',
  adminAddOutOfOfficeSaveButtonClicked = 'Admin Add Out Of Office Save Button Clicked',
  adminOutOfOfficeDeleteButtonClicked = 'Admin Out Of Office Delete Button Clicked',
  adminOutOfOfficeDeleteConfirmationModalDeleteOutOfOfficeButtonClicked = 'Admin Out Of Office Delete Confirmation Modal Delete Out Of Office Button Clicked',
  adminOutOfOfficeEditButtonClicked = 'Admin Out Of Office Edit Button Clicked',
  adminEditOutOfOfficeSaveButtonClicked = 'Admin Edit Out Of Office Save Button Clicked',
  adminCalendarCardClicked = 'Admin Calendar Card Clicked',
  permissionsEditButtonClicked = 'Permissions Edit Button Clicked',
  permissionsAdminToggleButtonToggled = 'Permissions Admin Toggle Button Toggled',
  permissionsMaudToggleButtonToggled = 'Permissions Maud Toggle Button Toggled',
  permissionsSaveChangesButtonClicked = 'Permissions Save Changes Button Clicked',
  addUserOptionClicked = 'Add User Option Clicked',
  addUserModalAddDisplayNameButtonClicked = 'Add User Modal Add Display Name Button Clicked ',
  addUserModalSaveChangesButtonClicked = 'Add User Modal Save Changes Button Clicked',
}
